import * as yup from 'yup';

const contactSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  number: yup
    .string()
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, 'Invalid number format')
    .required('Number is required'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  problem: yup.string().required('Please enter your comments.'),
});

export default contactSchema;
